import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ICountryModel } from './country';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';

// note: use FiCountryHelperService to get correct data;
@Injectable()
export class CountryService {
    constructor(private fiBackend: FiBackendService) {}

    GetCountryCodes(): Promise<ICountryModel[]> {
        return this.fiBackend.fetchData<ICountryModel[]>('Core/Country/GetCountryCodes');
    }

    GetCountryByUserLocation(): IFiHttpPromise<ICountryModel> {
        return this.fiBackend.fetchData<ICountryModel>('Core/Country/GetCountryByUserLocation');
    }
}
